import React, { useState, useEffect } from "react";
import SectionCard from "./SectionCard";
import { Form, Row, Col, Card, Spin } from "antd";
import ReusableInput from "./ReusableInput";
import ButtonComponent from "./Button_v2";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import { updateOrderDetails_v2 } from "../../api/OrdersApi";
import useItNumberSync from "../../hooks/useItNumberSync";

const { Item: FormItem } = Form;

const OrderLabelInfo = (props) => {
  const { getDataRef, labelInfo = {}, actionType = 'create', currentOrder, currentOrg, isShipper = false, showActions = true,
   orderTypeConfig,  selectedWarehouse, currentWhCode, originCode, destinationCode,isNew, currentLocType, onItNumberChange } = props;
  const [showForm, setShowForm] = useState(false);
  const [ isSaving, setIsSaving] = useState(false);
  const whCodeInfo = !_.isEmpty(selectedWarehouse) && selectedWarehouse?.location_code ? selectedWarehouse.location_code : '';
  const [activeRow, setActiveRow] = useState(null);
  const [sharedItNumber, setSharedItNumber] = useItNumberSync(currentOrder?.customer_order_details?.customer_order_id);

  const [formData, setFormData] = useState({
    origin_port: "",
    destination_port: "",
    it_number: "",
    routing: "",
    ...labelInfo
  });

     // Update the getDataRef to return the current state
     useEffect(() => {
      if (getDataRef) {
        getDataRef.current = () => (formData);
      }
    }, [formData, getDataRef]);


  useEffect(() => {
    if(actionType !== 'view') {
      setShowForm(true);
    }
  }, [actionType]);

  useEffect(() => {
    if (labelInfo?.it_number === undefined) return;

    setFormData(prev => (
      prev.it_number === labelInfo.it_number ? prev : { ...prev, it_number: labelInfo.it_number || "" }
    ));
  }, [labelInfo?.it_number]);

  useEffect(() => {
    if (sharedItNumber === undefined) return;

    setFormData(prev => (
      prev.it_number === sharedItNumber ? prev : { ...prev, it_number: sharedItNumber }
    ));
  }, [sharedItNumber]);

  // Update automatically origin_port and destination_port as warehouse code
  useEffect(() => {
    // Recompute whenever we have a warehouse OR a resolved warehouse code from the
    // zip lookup (originCode/destinationCode/currentWhCode). Previously this required
    // selectedWarehouse, so on an address change with no explicit warehouse selection
    // the origin/destination never refreshed (and saved empty).
    if (!orderTypeConfig || !['create', 'update'].includes(actionType)) return;
    if (!selectedWarehouse && !originCode && !destinationCode && !currentWhCode) return;
    const { type_of_order } = orderTypeConfig;

    let origin_port = '';
    let destination_port = '';

    if (['T', 'LH', 'MS', 'M'].includes(type_of_order)) {
      if(!currentLocType) {
        origin_port = isNew && !originCode ? currentWhCode : originCode;
        destination_port = isNew && !destinationCode ? currentWhCode : destinationCode;
      } else if(currentLocType === "PICKUP") {
        origin_port = isNew && !originCode ? currentWhCode : originCode;
        destination_port = isNew && !destinationCode && !currentWhCode ? whCodeInfo : isNew && !destinationCode ? currentWhCode : destinationCode;
      } else if(currentLocType === "DELIVERY") {
        destination_port = isNew && !destinationCode ? currentWhCode : destinationCode;
        origin_port = isNew && !originCode && !currentWhCode ? whCodeInfo : isNew && !originCode ? currentWhCode : originCode;
    } 
  }else if (type_of_order === 'R') {
      origin_port = isNew && !originCode ? currentWhCode : originCode;
      destination_port = destinationCode || '';
    } else if (type_of_order === 'D') {
      origin_port = originCode || '';
      destination_port = isNew && !destinationCode ? currentWhCode : destinationCode;
    } else {
      origin_port = labelInfo?.origin_port || '';
      destination_port = labelInfo?.destination_port || '';
    }

    setFormData(prev => ({
      ...prev,
      origin_port,
      destination_port,
    }));
  }, [orderTypeConfig, selectedWarehouse, currentWhCode, destinationCode, originCode]);

  // Handler to toggle form visibility
  const handleAddLabelInfo = () => {
    setShowForm(true);
  };

  const handleUpdateLabelInfo = () => {
     const details = _.get(currentOrder, "customer_order_details" , false)
     const payload = {
         customer_order_params: {
             customer_order_id: details.id,
             warehouse_id: details.warehouse_id,
             organization_id: currentOrg?.id || '',
             location_id:  location?.id || ''
         },
         label_info: {...formData},
         ref_block_params: {
           it_number: formData.it_number || "",
         },
     }
     setIsSaving(true)
     updateOrderDetails_v2(currentOrder.id, payload).then((result) => {
         if (result.success) {
          setIsSaving(false)
           renderNotification(
             `Order ${currentOrder?.customer_order_details?.customer_order_number || ''} details has been updated`,
             "success"
           );
           if (onItNumberChange && formData.it_number !== undefined) {
             onItNumberChange(formData.it_number);
           }
         } else {
          setIsSaving(false)
         }
       });
  };

  // Handler for input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (name === "it_number") {
      setSharedItNumber(value);
    }
  };

  // Handler for form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    // Logic to send formData to the backend
    console.log("Form data to send:", formData);
  };

  const renderLabelForm = () => {
    return(
      <Form onSubmit={handleSubmit}>
        <Spin spinning={isSaving}>
          <Row gutter={16}>
            <Col span={6} className="table-col" > {/* onClick={() => setActiveRow('origin_port')} */}
              <FormItem label="Origin" className="custom-form-item" >
                <ReusableInput
                  data-testid="origin-input"
                  name="origin_port"
                  placeholder=""
                  value={formData.origin_port}
                  onChange={handleChange}
                />
              </FormItem>
              {activeRow === 'origin_port' && (
                <Card
                  style={{
                      position: 'absolute',
                      top: 0, // Align to row top
                      right: 0, // Align top-right edge
                      width: '100%', // Set card width according to your requirement
                      zIndex: 1, // Ensure card appears above other rows
                  }}
                title="Details"
                >
                <p>Additional details for</p>
                </Card>
               )}
            </Col>
            <Col span={6} className="table-col">
              <FormItem label="Destination" className="custom-form-item">
                <ReusableInput
                  data-testid="destination-input"
                  name="destination_port"
                  placeholder=""
                  value={formData.destination_port}
                  onChange={handleChange}
                />
              </FormItem>
            </Col>
            <Col span={6} className="table-col">
              <FormItem label="IT Number" className="custom-form-item">
                <ReusableInput
                  data-testid="it-number-input" 
                  name="it_number"
                  placeholder=""
                  value={formData.it_number}
                  onChange={handleChange}
                />
              </FormItem>
            </Col>
            <Col span={6} className="table-col">
              <FormItem label="Routing" className="custom-form-item">
                <ReusableInput
                  data-testid="routing-input"
                  name="routing"
                  placeholder=""
                  value={formData.routing}
                  onChange={handleChange}
                />
              </FormItem>
            </Col>
          </Row>
          </Spin>
        </Form>
    )
  }
  const isReadOnly = actionType === 'view'
  return (
    <SectionCard
      title="Label Info"
      extraActionNode={
        showActions ? (
          ["view"].includes(actionType)? (
            <ButtonComponent
              data-testid="update-label-button"
              type="secondary"
              className="outline small-btn"
              onClick={handleUpdateLabelInfo}
              text="Update Label Info"
              disabled={isSaving}
            />
          ) : showForm ? null : (
            <ButtonComponent
              data-testid="add-label-info-button"
              type="secondary"
              className="outline small-btn"
              onClick={handleAddLabelInfo}
              text="Add Label Info"
            />
          )
        ) : null
      }
    >
      {["view"].includes(actionType)
        ? renderLabelForm()
        : showForm && renderLabelForm()}
    </SectionCard>
  );
};

export default OrderLabelInfo;